import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Leaf } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    const res = await login(email, password);
    setBusy(false);
    if (!res.ok) return setError(res.error);
    const next = new URLSearchParams(loc.search).get("next") || "/library";
    nav(next);
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20 md:py-24">
      <div className="text-center">
        <Leaf className="w-6 h-6 text-[var(--forest)] mx-auto" strokeWidth={1.5} />
        <p className="label-eyebrow mt-3">Sign in</p>
        <h1 className="font-serif text-4xl md:text-5xl mt-2">Welcome back.</h1>
      </div>
      <form onSubmit={submit} className="mt-10 space-y-7">
        <div>
          <label className="label-eyebrow">Email</label>
          <input data-testid="login-email-input" className="field mt-2" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
        </div>
        <div>
          <label className="label-eyebrow">Password</label>
          <input data-testid="login-password-input" className="field mt-2" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </div>
        {error && <p data-testid="login-error" className="text-sm text-[var(--terracotta)]">{error}</p>}
        <button data-testid="login-submit-btn" type="submit" disabled={busy} className="btn-primary w-full justify-center">
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
      <p className="mt-6 text-sm text-center text-[var(--ink-soft)]">
        New here? <Link data-testid="login-to-register" to="/register" className="underline underline-offset-4 decoration-[var(--terracotta)]">Create an account</Link>
      </p>
    </div>
  );
}
